export const tableInitialState = {
	columns: {
		profit_crm: {
			index: 'profit_crm',
			title: 'AV. PROFIT',
			className: 'short-col profit'
		},
		free_leads: {
			index: 'free_leads',
			title: 'FREE LEADS',
			className: ''
		},
		rest: {
			index: 'rest',
			title: 'THE REST',
			className: ''
		},
		stock: {
			index: 'stock',
			title: 'STOCK',
			className: ''
		}
	},
	sortByColumn: {
		index: '',
		direction: ''
	},
	rowsNumber: 1000
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table-additional/index.js